import {
  type ColumnBlockModel,
  ColumnsBlockModel,
} from '@blocksuite/affine-model';
import { matchModels } from '@blocksuite/affine-shared/utils';
import { BlockComponent } from '@blocksuite/std';
import { html, nothing } from 'lit';

import { columnHostStyles } from './styles.js';

export class ColumnBlockComponent extends BlockComponent<ColumnBlockModel> {
  /** True for every column but the first, which owns no left divider. */
  private get _hasDivider() {
    const parent = this.model.parent;
    if (!parent || !matchModels(parent, [ColumnsBlockModel])) return false;
    return parent.children.indexOf(this.model) > 0;
  }

  override connectedCallback() {
    super.connectedCallback();
    this.classList.add(columnHostStyles);
  }

  override renderBlock() {
    // Reading the signal keeps the width reactive to undo/redo and to remote
    // edits, not just to our own resize commit.
    const width = this.model.props.width$.value;
    this.style.flex = `${width} 1 0`;

    return html`
      ${
        this._hasDivider
          ? html`<affine-column-divider
              .column=${this}
            ></affine-column-divider>`
          : nothing
      }
      <div class="affine-block-children-container">
        ${this.renderChildren(this.model)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'affine-column': ColumnBlockComponent;
  }
}
